import { Box, Text } from '@ltvco/refresh-lib/theme';
import { FC } from 'react';

import { RecallsCardsGrid } from '../components/components';
import { RecallCard } from '../components/RecallCard';

import type { NormalizedRecallCard } from '../interfaces';

interface SimilarRecallsProps {
  cards: NormalizedRecallCard[];
  onCardClick?: (card: NormalizedRecallCard) => void;
}

export const SimilarRecalls: FC<SimilarRecallsProps> = ({
  cards,
  onCardClick,
}) => {
  const displayCards = (cards ?? []).slice(0, 3);

  if (displayCards.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Text component="h3" sx={{ fontWeight: 700, fontSize: 24, m: 0, mb: 2 }}>
        Similar Recalls
      </Text>
      <RecallsCardsGrid>
        {displayCards.map((card, index) => (
          <RecallCard
            key={card.recallNumber ?? `${card.title}-${index}`}
            card={card}
            onClick={onCardClick ? () => onCardClick(card) : undefined}
          />
        ))}
      </RecallsCardsGrid>
    </Box>
  );
};
